
import React, {Suspense, lazy} from "react";
import {BrowserRouter as Router, Routes as Switch, Route} from 'react-router-dom'
import { Home, Series, Movies, Search, WatchLaterList, Studio, Watch_Movie_TV_Show, Intro} from "./pages"
import SideBar from './components/SideBar';
import ScrollToTop from './components/scrollToTop';

// const Series = lazy(() => import('./pages/Series'));
// const Movies = lazy(() => import('./pages/Movies'))
// const Search = lazy(() => import('./pages/Search'))
// const WatchLaterList = lazy(() => import('./pages/WatchLaterList'))
// const Studio = lazy(() => import('./pages/Studio'))
// const Watch_Movie_TV_Show = lazy(() =>import('./pages/Watch_Movie_TV_Show'))

function App() {
  return (
    <div className="page">
      <Router>
        <ScrollToTop /> 
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <Route exact path =  "/" element = {<Intro/>}/>
            <Route path = "/home" element = {<Home/>}/>
            <Route path = "/shows" element = {<Series/>}/>
            <Route path = "/movies" element = {<Movies/>}/>
            <Route path = "/:name" element = {<Search />} />
            <Route path = "/watchlist" element = {<WatchLaterList />} />
            <Route path = "/studio/:studioName" element = {<Studio/>}/>
            <Route path = "/:movie_tv/:name/:id" element = {<Watch_Movie_TV_Show/>} />
          </Switch>
        </Suspense>
      </Router>
    </div>
  );
}


export default App;
